<template>
  <div class="privacy-agreement px-to-viewport-ignore">
    <p class="title">{{ appName }}隐私政策</p>
    <div style="margin-bottom: 10px">
      <p class="s">版本更新日期：2026年09月23日</p>
    </div>
    <p class="t1">概要</p>
    <div class="d"
      >欢迎您使用{{ appName }}！{{ appName }}是由{{
        companyName
      }}（以下简称“我们”）研发和运营的健康类服务平台，我们将通过《{{
        appName
      }}隐私政策》帮助您了解我们收集、使用、存储和共享个人信息的情况，以及您所享有的相关权利。</div
    >
    <ul class="d">
      <li
        >为了向您提供健康类服务方案，我们需要收集您在使用服务时主动提供的或因为使用服务而产生的信息，我们会向您说明上述信息的类型和对应的用途；</li
      >
      <li>您可以在相关页面访问、更正、删除您的个人信息并管理您的授权； </li>
      <li>我们会采用业界领先的安全技术保护好您的个人信息。 </li>
    </ul>
    <div class="b d">
      请您在使用{{ appName }}服务前仔细阅读并了解《{{
        appName
      }}隐私政策》,特别是以粗体字标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。
    </div>
    <div class="t1">一、我们收集的信息</div>
    <div class="d">
      <p
        >{{
          appName
        }}为了保障您的账号安全和系统安全，我们需要获取您的设备信息</p
      >
      <p class="t1">Android&IOS</p>
      <p
        >我们将获取您的MAC地址、IMSI、Android
        ID、IP地址、硬件型号、操作系统版本号、唯一设备标识符（例如IMEI、MAC、IMSI识别码）、电路卡识别码(ICCID)、网络设备硬件地址（MAC）、软件版本号、网络接入方式、类型、状态、网络质量数据、操作日志、设备序列号、服务日志信息，APP崩溃记录、流量统计、操作日志.收集运行中的进程，已安装应用列表等行为。
      </p>
      <p
        >当您使用Android&IOS
        {{ appName }}以下功能时，我们需要您提供相应的权限许可：</p
      >
      <p class="t2">1、摄像头、相机权限</p>
      <p v-if="isCoach">为了您可以修改个人头像 ,在点击上传图片时，我们将申请获取您的相机权限以及图库权限,获取您选择或者拍摄的图片资源。</p>
      <p v-else>为了您可以使用饮食打卡的功能以及修改个人头像 ,在点击上传图片时，我们将申请获取您的相机权限以及图库权限,获取您选择或者拍摄的图片资源。</p>
      <p class="t2">2、相册/存储权限</p>
      <p v-if="isCoach">为了您可以使用饮食打卡的功能,更换个人头像、缓存资讯信息、使用图片的缓存、上传、保存、识别、编辑与分享功能.我们将申请允许获取您的相册权限及手机存储权限,获取的设备的图片资源以及增加缓存。当您选择上传带有地理位置信息的图片时，我们可能读取图片中嵌入的位置信息；您可在系统相册设置中关闭"位置信息"以免写入。当您需要打开或分享视频、音频等文件时，我们将申请读取媒体文件权限（READ_MEDIA_VIDEO、READ_MEDIA_AUDIO），仅用于文件打开与分享功能。</p>
      <p v-else>为了您可以更换个人头像、缓存资讯信息、使用图片的缓存、上传、保存、识别、编辑与分享功能.我们将申请允许获取您的相册权限及手机存储权限,获取的设备的图片资源以及增加缓存。当您选择上传带有地理位置信息的图片时，我们可能读取图片中嵌入的位置信息；您可在系统相册设置中关闭"位置信息"以免写入。当您需要打开或分享视频、音频等文件时，我们将申请读取媒体文件权限（READ_MEDIA_VIDEO、READ_MEDIA_AUDIO），仅用于文件打开与分享功能。</p>
      <p class="t2">3、通知权限</p>
      <p
        >为了给您提供重点事项的通知（如评论、预警、活动、行业重要公告、系统升级等）、服务资讯的推送等,我们将会申请通知权限</p
      >
      <p class="t2">4、WIFI及蜂窝数据的权限</p>
      <p>为了您可以正常使用App 获取到数据 我们将会申请WLAN与蜂窝移动网权限</p>
      <p class="t2">5、app安装外部应用的权限(仅限Android手机)</p>
      <p
        >应用更新时,app内提示版本更新,如若是需要使用内部更新,将会申请使用app安装外部应用的权限</p
      >
      <p class="t2">6、位置信息权限</p>
      <p>
        为了使用应用内约课功能时,获取位置信息便于获取附近可约课场馆,以及上课的时候核销课程 我们将申请定位信息的权限。在您使用约课等需要持续获取位置的场景时，即便 App 切换至后台，我们仍会收集您的精确位置信息（后台定位）。我们仅在您开启相关功能且获得您单独授权后，在必要范围内收集后台位置，用于距离数据统计分析。您可以随时在系统设置中关闭后台定位授权。
        </p>
      <p class="t2">7、日历权限</p>
      <p
        >为了您可以使用喝水提醒、课程提醒等功能，在使用应用内喝水提醒、课程提醒功能期间，我们将申请获取您的日历权限，用于向您发送提醒。</p
      >
      <p class="t2">8、自启动和关联启动说明</p>
      <p
        >1、为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。</p
      >
      <p
        >2、当您打开{{ appName }}内容类推送消息，在征得您的明确同意后，会跳转{{
          appName
        }}打开相关内容。在未征得您同意的情况下，则不会有关联启动。</p
      >
      <p>3、当您打开{{ appName }}内部下载的文件后，会关联启动第三方APP。</p>
      <p class="t2">9、蓝牙传感器权限</p>
      <p
        >为了您可以使用健康管理-测量体脂数据的功能，在使用应用内健康管理-测量体脂数据功能期间，我们将申请获取您的蓝牙权限以及使用蓝牙传感器权限，用于连接体脂秤设备。</p
      >
      <p class="t2">10、健康测量数据</p>
      <p>
        当您使用"测量体脂数据"功能并通过蓝牙连接体脂秤时，我们会收集您主动测量的体重、体脂率等身体健康数据。该类信息属于敏感个人信息，我们将在您同意后收集，并仅在提供数据分析服务范围内使用，您可在记录列表随时删除相关记录。
      </p>
      <p class="t2">11、电话权限（读取手机状态，仅限Android手机）</p>
      <p
        >为了实现消息推送、一键登录、数据统计分析功能，第三方SDK（腾讯TPNS、友盟统计、创蓝闪验）需要读取手机状态，用于获取设备标识信息（如IMSI）。我们仅在为实现上述功能所必需的范围内使用该信息。</p
      >
      <p
        >为实现上述功能，第三方SDK在运行期间还会申请网络状态、唤醒锁、任务栈管理、精确闹钟等运行所需权限，上述权限仅用于保障相应功能的正常运行。</p
      >
    </div>
    <div class="d">
      <p class="t1">鸿蒙系统(Harmony Next)</p>
      <p
        >我们将获取您的MAC地址、Harmony
        OAID、IP地址、硬件型号、操作系统版本号、唯一设备标识符（例如IMEI、MAC、IMSI识别码）网络设备硬件地址（MAC）、软件版本号、网络接入方式、类型、状态、网络质量数据、操作日志、设备序列号、服务日志信息，APP崩溃记录、流量统计、操作日志.收集运行中的进程，已安装应用列表等行为。
      </p>
      <p
        >当您使用鸿蒙系统{{
          appName
        }}以下功能时，我们需要您提供相应的权限许可：</p
      >
      <p class="t2">1、摄像头、相机权限</p>
      <p
        >为了您可以使用饮食打卡的功能以及修改个人头像
        ,在点击上传图片时，我们将申请获取您的相机权限以及图库权限,获取您选择或者拍摄的图片资源。</p
      >
      <p class="t2">2、相册权限及手机存储权限</p>
      <p
        >为了您可以使用饮食打卡的功能,更换个人头像、缓存资讯信息、使用图片的缓存、上传、保存、识别、编辑与分享功能.我们将申请允许获取您的相册权限及手机存储权限,获取的设备的图片资源以及增加缓存</p
      >
      <p class="t2">3、WIFI及蜂窝数据的权限</p>
      <p>为了您可以正常使用App 获取到数据 我们将会申请WLAN与蜂窝移动网权限</p>
      <p class="t2">4、位置信息权限</p>
      <p
        >为了使用应用内约课功能时,获取位置信息便于获取附近可约课场馆,以及上课的时候核销课程
        我们将申请定位信息的权限</p
      >
      <p class="t2">5、日历权限</p>
      <p
        >为了您可以使用喝水提醒、课程提醒等功能，在使用应用内喝水提醒、课程提醒功能期间，我们将申请获取您的日历权限，用于向您发送提醒。</p
      >
      <p class="t2">6、蓝牙传感器权限</p>
      <p
        >为了您可以使用健康管理-测量体脂数据的功能，在使用应用内健康管理-测量体脂数据功能期间，我们将申请获取您的蓝牙权限以及使用蓝牙传感器权限，用于连接体脂秤设备。</p
      >
    </div>
    <!--  <div class="d">
            <p>在您使用betterWE星球服务的过程中，我们会按照如下方式收集您在使用服务时主动提供的或因为使用服务而产生的信息，用以向您提供服务、优化我们的服务以及保障您的账户安全。</p>
            <p>betterWEApp了保障您的账号安全和系统安全，我们需要获取您的设备MAC地址、IMSI、Android ID、IP地址、硬件型号、操作系统版本号、唯一设备标识符（例如IMEI、MAC、IMSI识别码）、电路卡识别码(ICCID)、网络设备硬件地址（MAC）、软件版本号、网络接入方式、类型、状态、网络质量数据、操作日志、设备序列号、服务日志信息，APP崩溃记录、流量统计、操作日志.收集运行中的进程，已安装应用列表等行为。</p>
            <p>当您使用betterWE星球以下功能时，我们需要您提供相应的权限许可：</p>
            <p class="t2">1、摄像头、相机权限</p>
            <p>为了您可以使用饮食打卡的功能以及修改个人头像 ,在点击上传图片时，我们将申请获取您的相机权限以及图库权限,获取您选择或者拍摄的图片资源。</p>
            <p class="t2">2、相册权限及手机存储权限</p>
            <p>为了您可以使用饮食打卡的功能,更换个人头像、缓存资讯信息、使用图片的缓存、上传、保存、识别、编辑与分享功能.我们将申请允许获取您的相册权限及手机存储权限,获取的设备的图片资源以及增加缓存</p>
            <p  class="t2">3、通知权限</p>
            <p>为了给您提供重点事项的通知（如评论、预警、活动、行业重要公告、系统升级等）、服务资讯的推送等,我们将会申请通知权限</p>
            <p  class="t2">4、WIFI及蜂窝数据的权限</p>
            <p>为了您可以正常使用App 获取到数据 我们将会申请WLAN与蜂窝移动网权限</p>
            <p  class="t2">5、app安装外部应用的权限(仅限Android手机)</p>
            <p>应用更新时,app内提示版本更新,如若是需要使用内部更新,将会申请使用app安装外部应用的权限</p>
            <p  class="t2">6、位置信息权限</p>
            <p>为了使用应用内约课功能时,获取位置信息便于获取附近可约课场馆,以及上课的时候核销课程 我们将申请定位信息的权限</p>
            <p  class="t2">7、日历权限</p>
            <p>为了您可以使用喝水提醒的功能，在使用应用内喝水提醒功能期间，我们将申请获取您的日历权限，用于向您发送提醒。</p>
            <p  class="t2">8、自启动和关联启动说明</p>
            <p>1、为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的广播信息，本应用须使用(自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。</p>
            <p>2、当您打开betterWE App内容类推送消息，在征得您的明确同意后，会跳转betterWE App打开相关内容。在未征得您同意的情况下，则不会有关联启动。</p>
            <p>3、当您打开betterWE App内部下载的文件后，会关联启动第三方APP。</p>
            <p  class="t2">9、蓝牙传感器权限</p>
            <p>为了您可以使用健康管理-测量体脂数据的功能，在使用应用内健康管理-测量体脂数据功能期间，我们将申请获取您的蓝牙权限以及使用蓝牙传感器权限，用于连接体脂秤设备。</p>
        </div> -->
    <div class="t1">二、我们使用的第三方服务</div>
    <div class="d">
      <p class="t1">Android/iOS</p>
      <p class="t2">1、推送服务腾讯TPNS</p>
      <p>第三方名称：深圳市腾讯计算机系统有限公司</p>
      <p>功能：向用户推送内容、通知等</p>
      <p
        >涉及的个人信息/权限类型:设备信息 [
        设备信息]包括：设备标识符（IMEI、IDFA、Android
        ID、MAC、OAID、IMSI、ICCID等相关信息）、应用信息（应用崩溃信息、通知开关状态、软件列表等相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息）]、网络信息[
        网络信息包括：IP地址，WiFi信息，基站信息等相关信息。
        ]、地理位置信息。</p
      >
      <p
        >如您使用部分手机厂商（如小米、华为、VIVO、OPPO等品牌）的手机使用{{
          appName
        }}，我们接入的上述手机厂商Push
        SDK需要收集手机唯一标识信息（例如IMEI），并可能会收集您的手机型号、系统类型、系统版本、设备屏幕尺寸等参数用于实现我们产品信息的推送，具体情况请参见SDK运营方的隐私政策或相关声明，具体如下：</p
      >
      <table>
        <tbody>
          <tr>
            <td>第三方SDK名称</td>
            <td>SDK 用途</td>
            <td>隐私政策链接</td>
            <td>收集个人信息类型</td>
          </tr>
          <tr>
            <td>小米推送 SDK</td>
            <td>对小米品牌手机消息推送</td>
            <td>
              <a href="https://privacy.mi.com/all/zh_CN/"
                >https://privacy.mi.com/all/zh_CN/</a
              >
            </td>
            <td>网络状态信息、设备信息、存储信息</td>
          </tr>
          <tr>
            <td>华为推送 SDK</td>
            <td>对华为品牌手机消息推送</td>
            <td>
              <a href="https://www.huawei.com/cn/privacy-policy"
                >https://www.huawei.com/cn/privacy-policy</a
              >
            </td>
            <td>网络状态信息、设备信息、存储信息、位置信息</td>
          </tr>
          <tr>
            <td>OPPO 推送 SDK</td>
            <td>对 OPPO 品牌手机消息推送</td>
            <td>
              <a href="https://www.oppo.com/cn/support/service-policy/privacy/#"
                >https://www.oppo.com/cn/support/service-policy/privacy/#</a
              >
            </td>
            <td
              >网络状态信息、设备信息（手机Region设置，设备型号，手机电量，手机操作系统版本及语言、网络配置信息）</td
            >
          </tr>
          <tr>
            <td>vivo 推送 SDK</td>
            <td>对vivo品牌手机消息推送</td>
            <td>
              <a href="https://www.vivo.com.cn/about-vivo/privacy-policy"
                >https://www.vivo.com.cn/about-vivo/privacy-policy</a
              >
            </td>
            <td>设备信息</td>
          </tr>
          <tr>
            <td>魅族推送 SDK</td>
            <td>对魅族品牌手机消息推送</td>
            <td>
              <a href="https://i.flyme.cn/privacy?lang=zh_CN"
                >https://i.flyme.cn/privacy?lang=zh_CN</a
              >
            </td>
            <td
              >设备信息（设备名称，设备型号，设备识别码及硬件信息），位置信息</td
            >
          </tr>
          <tr>
            <td>APNs SDK</td>
            <td>对苹果品牌手机消息推送</td>
            <td>
              <a href="https://www.apple.com/legal/privacy/en-ww/"
                >https://www.apple.com/legal/privacy/en-ww/</a
              >
            </td>
            <td
              >设备信息（设备序列号，设备属性信息），位置信息，网络状态信息</td
            >
          </tr>
        </tbody>
      </table>
      <p>隐私政策链接：https://cloud.tencent.com/document/product/548/50955</p>
      <p class="t2">2、友盟</p>
      <p>第三方名称：友盟同欣（北京）科技有限公司、北京锐讯灵通科技有限公司</p>
      <p>功能：数据统计分析，帮助开发者了解应用使用情况，以优化产品与服务</p>
      <p>
        涉及的个人信息/权限类型：设备标识符（IMEI、OAID（替代IMEI）、AndroidID、IMSI、BSSID、SSID、GAID、MCC及MNC、设备序列号、SIM卡序列号）、设备网络信息（设备MAC地址、RSSI）、位置信息、存储信息、应用列表
      </p>
      <p>隐私政策链接：https://www.umeng.com/page/policy</p>
      <p class="t2">3、创蓝闪验SDK</p>
      <p>第三方名称：上海创蓝文化传播有限公司</p>
      <p>
        功能：用于帮助实现用户一键登录行为。为了实现网关取号技术，闪验SDK需要获取IP地址、网卡（MAC）地址、国际移动设备识别码（IMEI）、OAID（替代IMEI）、sim卡信息，并会收集手机机型、系统类型、系统版本、网络环境、网关取号报错日志等数据以提供统计分析服务能力，并可提供反欺诈等功能。
        闪验认证SDK整合了三大运营商的号码认证能力，为APP开发者提供了一键登录及快速验证用户输入的手机号码和本机流量卡号一致性的服务,并集成电信/联通/移动
        SDK 在一键登录时使用</p
      >
      <p>隐私政策链接：https://doc.chuanglan.com/document/7E5OGNR5L1K63VOL</p>
      <p class="t2">4、腾讯Bugly</p>
      <p>第三方名称：腾讯科技（深圳）有限公司</p>
      <p>功能：收集用户崩溃日志信息，提升app稳定性。</p>
      <p
        >涉及的个人信息/权限类型：Mac地址、设备序列号、硬件序列号、唯一设备识别码（IMEI、androidID（android_ID/android_id/IDFA/OPENUDID
        /GUID、SIM 卡 IMSI 信息）</p
      >
      <p>隐私政策链接：https://privacy.qq.com/policy/tencent-privacypolicy</p>
      <p class="t2">5、巨量引擎转化SDK</p>
      <p>第三方名称：北京巨量引擎网络技术有限公司</p>
      <p
        >功能：提供数据统计和分析服务,基于广告的投放采集用户的广告行为、部分设备信息，以及开发者的应用程序内的部分转化事件，用于广告监测归因、投放效果优化等与广告活动相关的使用目的</p
      >
      <p>涉及的个人信息/权限类型：</p>
      <p>【Android】设备品牌、型号、软件系统版本相关信息、oaid等基础信息</p>
      <p
        >【IOS】设备品牌、型号、软件系统版本相关信息、手机系统重启时间、磁盘总空间、系统总内存空间、CPU数目等基础信息</p
      >
      <p
        >Mac地址、唯一设备识别码（IMEI、androidID（android_ID/android_id/IDFA/OPENUDID
        /GUID、SIM 卡 IMSI 信息）</p
      >
      <p>应用信息 ：开发者应用名、应用包名、版本号等信息</p>
      <p>其他信息： 运营商信息、设备时区</p>
      <p
        >隐私政策链接：https://event-manager.oceanengine.com/docs/8650/194615</p
      >
      <p class="t2">6、火山引擎增长营销套件</p>
      <p>第三方名称：北京火山引擎科技有限公司</p>
      <p
        >功能：通过多渠道触达、数据驱动的用户分群、智能推荐算法及自动化营销策略，实现精准用户运营与业务增长目的</p
      >
      <p>涉及的个人信息/权限类型：</p>
      <p
        >【Android】设备品牌、型号、软件系统版本相关信息，设备标识Mac地址、OAID、MEID、ICCID、IMEI、Android
        ID</p
      >
      <p
        >【【IOS】设备品牌、型号、软件系统版本相关信息、手机系统重启时间、磁盘总空间、系统总内存空间、CPU数目等基础信息，IDFA唯一标识</p
      >
      <p>隐私政策链接：https://www.volcengine.com/docs/6315/1171066</p>
      <p class="t2">7、微信Open SDK</p>
      <p>第三方名称：深圳市腾讯计算机系统有限公司</p>
      <p>功能：使用微信分享、微信登录</p>
      <p
        >涉及的个人信息/权限类型：MAC地址和唯一设备识别码、微信ID、头像、昵称</p
      >
      <p
        >隐私政策链接：微信Open SDK个人信息处理规则
        https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</p
      >
      <p class="t2">8、高德定位SDK</p>
      <p>第三方名称：高德软件有限公司</p>
      <p>功能：地图展示与定位；</p>
      <p>涉及的个人信息： 精确/粗略位置、设备标识符、网络信息；</p>
      <p>隐私政策链接： https://lbs.amap.com/home/privacy</p>
      <p class="t2">9、腾讯云点播（VOD）SDK</p>
      <p>第三方名称：腾讯云计算（北京）有限责任公司</p>
      <p
        >涉及的个人信息：视频播放与画中画；收集信息
        设备信息、网络信息、播放行为日志</p
      >
      <p>隐私政策链接：https://cloud.tencent.com/document/product/266/71352</p>
      <p class="t2">10、PingWang 蓝牙通信 SDK</p>
      <p>第三方名称：浙江天晟电子有限公司</p>
      <p>功能：连接体脂秤设备并读取测量数据</p>
      <p>涉及的个人信息：蓝牙设备标识、体脂测量数据</p>
      <p
        >隐私政策链接：https://cftweb.3g.qq.com/privacy/privacyPolicy?content_id=64b56513336748ee854d0d49146d70ee</p
      >
      <p class="t2">11、阿里云对象存储（OSS）</p>
      <p>第三方名称：阿里云计算有限公司</p>
      <p>功能：存储用户上传的内容（头像、打卡图片及视频）</p>
      <p>涉及的个人信息：您上传的图片/视频内容、网络信息</p>
      <p>隐私政策链接：https://terms.alicdn.com/legal-agreement/terms/privacy_policy_full/20240202100310511/20240202100310511.html</p>
      <p class="t2">12、移动安全联盟（MSA）OAID SDK</p>
      <p>第三方名称：移动智能终端生态发展联盟</p>
      <p>功能：获取设备标识符OAID，用于消息推送、数据统计分析与广告归因</p>
      <p>涉及的个人信息：OAID、设备信息</p>
      <p>隐私政策链接：http://www.msa-alliance.cn/</p>
    </div>
    <div class="d">
      <p class="t1">鸿蒙系统(Harmony Next)</p>
      <p class="t2">1、微信Open SDK</p>
      <p>第三方名称：深圳市腾讯计算机系统有限公司</p>
      <p>功能：使用微信分享、微信登录</p>
      <p
        >涉及的个人信息/权限类型：MAC地址和唯一设备识别码、微信ID、头像、昵称</p
      >
      <p
        >隐私政策链接：微信Open SDK个人信息处理规则
        https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</p
      >
      <p class="t2">2.移动推送 SDK(TPNS)</p>
      <p>第三方名称：深圳市腾讯计算机系统有限公司</p>
      <p>SDK 用途：在移动终端设备进行消息推送</p>
      <p>涉及个人信息类型：</p>
      <p
        >(1)、
        设备信息(手机型号，系统类型、系统版本等)用于标签化推送以及识别是否是真机、网络信息(网络类型)支持根据不同网络类型进行不同类型推送、应用数据（AAID（应用匿名标识符）推送流程中产生的送达、点击、曝光等数据）用于推送业务数据统计。
      </p>
      <p
        >(2)、（可选信息，依赖开发者设置）账号绑定信息(根据您所选用的不同推送渠道，QQ号、微信Union
        ID、 手机号、邮箱等)用于根据账号信息进行推送</p
      >
      <p>数据处理方式：通过去标识化、加密传输及其他安全方式</p>
      <p>官网链接：https://cloud.tencent.com/product/tpns</p>
      <p
        >隐私政策链接：https://privacy.qq.com/document/preview/8565a4a2d26e480187ed86b0cc81d727</p
      >
    </div>
    <div class="d">
      <p class="t1">三、信息的存储</p>
      <p class="t2">1.信息存储的方式和期限</p>
      <p
        >我们会通过安全的方式存储您的信息，包括本地存储（例如利用APP进行数据缓存）、数据库和服务器日志。</p
      >
      <p
        >我们只会在为实现服务目的所必需的时间内或法律法规规定的条件下存储您的个人信息。您可以自主选择删除手机号码、收货地址等您在使用{{
          appName
        }}服务时提供的个人信息以及流量统计信息等因为使用服务而产生的信息。如果您选择删除上述信息，我们也将相应删除相应的个人信息。</p
      >
      <p class="t2">2.信息存储的地域</p>
      <p>我们会按照法律法规规定，将境内收集的用户个人信息存储于中国境内。</p>
      <p
        >目前我们不会跨境传输或存储您的个人信息。将来如需跨境传输或存储的，我们会向您告知信息出境的目的、接收方、安全保证措施和安全风险，并征得您的同意。</p
      >
      <p class="t2">3.产品或服务停止运营时的通知</p>
      <p
        >当我们的产品或服务发生停止运营的情况时，我们将以推送通知、公告等形式通知您，并在合理期限内删除您的个人信息或进行匿名化处理，法律法规另有规定的除外。</p
      >
    </div>
    <div class="d">
      <p class="t1">四、信息安全</p>
      <p class="t2">1.安全保护措施 </p>
      <p
        >我们努力为用户的信息安全提供保障，以防止信息的泄露、丢失、不当使用、未经授权访问和披露等。我们使用多方位的安全保护措施，以确保用户的个人信息保护处于合理的安全水平，包括技术保护手段、管理制度控制、安全体系保障等诸多方面。
      </p>
      <p>
        我们采用业界领先的技术保护措施。我们使用的技术手段包括但不限于防火墙、加密（例如SSL）、去标识化或匿名化处理、访问控制措施等。此外，我们还会不断加强安装在您设备端的软件的安全能力。例如，我们会在您的设备本地完成部分信息加密工作，以巩固安全传输；我们会了解您设备安装的应用信息和运行的进程信息，以预防病毒、木马等恶意程序。
      </p>
      <p>
        我们建立了保障个人信息安全专门的管理制度、流程和组织。例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务并进行审计，违反义务的人员会根据规定进行处罚。我们也会审查该管理制度、流程和组织，以防未经授权的人员擅自访问、使用或披露用户的信息。
      </p>
      <p
        >我们建议您在使用产品和服务时充分注意对个人信息的保护，我们也会提供多种安全功能来协助您保护自己的个人信息安全。</p
      >
      <p class="t2">2.安全事件处置措施</p>
      <p>
        若发生个人信息泄露、损毁、丢失等安全事件，我们会启动应急预案，阻止安全事件扩大。安全事件发生后，我们会及时以推送通知、邮件等形式告知您安全事件的基本情况、我们即将或已经采取的处置措施和补救措施，以及我们对您的应对建议。如果难以实现逐一告知，我们将通过公告等方式发布警示。
      </p>
    </div>
    <div class="d">
      <p class="t1">五、我们如何使用信息</p>
      <p
        >我们严格遵守法律法规的规定以及与用户的约定，按照本隐私政策所述使用收集的信息，以向您提供更为优质的服务。</p
      >
      <p class="t2">1.信息使用规则</p>
      <p
        >除在信息收集部分说明的使用方式外，您在使用我们的服务时，我们可能根据您的联系方式向您发送短信、资讯或推送通知。您可以按照我们的相关提示，在设备上选择取消订阅。</p
      >
      <p
        >我们可能在必要时（例如，因系统维护而暂停某一项服务，因产品能力变更而停止某项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于广告的公告。</p
      >
      <p>
        我们将会在本隐私政策所涵盖的用途内使用收集的信息。如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的明示同意。</p
      >
    </div>
    <div class="d">
      <p class="t1">六、对外提供</p>
      <p>
        目前，除产品功能必须外，我们不会主动共享或转让您的个人信息至第三方，如存在其他共享或转让您的个人信息或您需要我们将您的个人信息共享或转让至第三方情形时，我们会直接或确认第三方征得您对上述行为的明示同意。需要说明的是，当您使用{{
          appName
        }}极速版直播或回放功能时，我们将提供您的账号、姓名及手机号至课堂老师实现教学互动以及教学考勤统计。</p
      >
      <p
        >我们不会对外公开披露所收集的个人信息，如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。</p
      >
      <p
        >随着我们业务的持续发展，我们有可能进行合并、收购、资产转让等交易，我们将告知您相关情形，按照法律法规及不低于本隐私政策所要求的标准继续保护或要求新的控制者继续保护您的个人信息。</p
      >
      <div class="b">
        <p
          >另外，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息无需事先征得您的授权同意：</p
        >
        <p>1.与国家安全、国防安全直接相关的；</p>
        <p>2.与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p>3.与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
        <p
          >4.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p
        >
        <p>5.个人信息主体自行向社会公众公开个人信息的；</p>
        <p
          >6.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</p
        >
      </div>
    </div>
    <div class="d">
      <p class="t1">七、您的权利</p>
      <p class=""
        >在您使用{{
          appName
        }}期间，为了让您更便捷地查询访问、删除、更正您的个人信息，同时保障您撤回个人信息使用的同意和注销账户的权利，我们在产品设计中为您提供了相应的操作设置，您可参考下面的指引进行操作。此外，我们还设置了投诉举报渠道，您的意见将会得到及时的处理。
      </p>
      <p class="t2">1.访问个人信息</p>
      <ul>
        <li>访问微信号、QQ号、头像、昵称等基本信息：</li>
      </ul>
      <p>(1)进入健盟后，点击“我的”-“个人信息“；</p>
      <p>(2)进行信息查询访问。</p>
      <p class="t2">2. 更正个人信息</p>
      <ul>
        <li>修改个人手机号信息</li>
      </ul>
      <p>(1)进入{{ appName }}后，点击“我的”-“个人信息；</p>
      <p>(2)进行信息更正。</p>
      <p class="t2">3. 撤回同意</p>
      <ul>
        <li>撤回日历、文件存储和访问、相机授权同意：</li>
      </ul>
      <p>(1)iOS系统-设置-选择{{ appName }}，关闭相关授权；</p>
      <p>(2)Android系统-设置-应用管理-{{ appName }}-权限管理，关闭相关授权。</p>
      <p class="t2">4. 退出登录</p>
      <ul>
        <li>退出关联账号登录</li>
      </ul>
      <p>(1)进入{{ appName }}后，点击“我的”;</p>
      <p>(2)点击“设置”;</p>
      <p>(3)点击“退出登录”。</p>
      <p class="t2">5. 账号注销</p>
      <ul>
        <li>注销关联账号</li>
      </ul>
      <p>(1)进入{{ appName }}后，点击“我的”;</p>
      <p>(2)点击“设置”;</p>
      <p>(3)点击“注销账号”。</p>
    </div>
    <div class="d b">
      <p class="t1">八、变更</p>
      <p>
        我们可能会适时对本隐私政策进行修订。当隐私政策的条款发生变更时，我们会在版本更新时以适当的方式向您提示变更后的隐私政策，并向您说明生效日期。请您仔细阅读变更后的隐私政策内容，您继续使用{{
          appName
        }}表示您同意我们按照更新后的隐私政策处理您的个人信息。
      </p>
    </div>
    <div class="d b" v-if="isCoach">
      <p class="t1">九、未成年人保护</p>
      <p class="d"
        >我们非常重视对未成年人个人信息的保护。我们会根据相关法律法规的规定，要求不满十四周岁的未成年人在使用{{
          appName
        }}的服务或向我们提供个人信息前，应当事先取得自己的监护人（比如自己的父母）的授权同意；已满十四周岁未满十八周岁的未成年人，可以事先取得自己的监护人的授权同意或自行授权同意。</p
      >
      <p class="d"
        >我们仅在法律法规允许、未成年人的监护人明确同意或者有必要保护未成年人的情况下使用、对外提供或公开披露该信息。</p
      >
      <p
        >若您是未成年人的监护人，请您关注您监护的未成年人是否是在取得您的授权同意之后使用{{
          appName
        }}的服务。如果您对您所监护的未成年人的个人信息有疑问，请通过第10节中的联系方式与我们联系。</p
      >
    </div>
    <div class="d b" v-else>
      <p class="t1">九、未成年人保护</p>
      <p class="d" >betterwe教练仅对betterwe认证教练开放注册和使用，禁止未成年人（未满 18 周岁）以任何方式注册、登录、访问或使用本 APP，如您为未成年人（未满 18 周岁），请立即停止使用betterwe教练。</p>
    </div>
    <div class="d b">
      <p class="t1">十、其他</p>
      <p
        >《{{ appName }}隐私政策》是{{
          companyName
        }}统一适用的一般性隐私条款，其中所规定的用户权利及信息安全保障措施均适用于{{
          appName
        }}。</p
      >
    </div>
    <div class="d b">
      <p class="t1">十一、联系我们</p>
      <p class="d"
        >当您有其他的投诉、建议、未成年人个人信息相关问题或需要删除所有访问记录时，请通过客服QQ
        3007264321与我们联系。您也可以将您的问题发送至wegymer01@163.com或寄到如下地址：</p
      >
      <p class="d"
        >湖南省长沙市开福区洪山街道万家丽北路一段899号月湖兰庭1号栋401房</p
      >
      <p class="d">邮编：410000</p>
      <p>我们将尽快审核所涉问题，并在验证您的用户身份后的十五天内予以回复。</p>
    </div>
    
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      appName: 'betterWE星球',
      companyName: '长沙健盟网络科技有限公司'
    }
  },
  computed: {
    isCoach() {
      return this.$route.query.appName === 'betterwe教练'
    }
  },
  created() {
    let appName = this.$route.query.appName
    let companyName = this.$route.query.companyName
    this.appName = appName ?? this.appName
    this.companyName = companyName ?? this.companyName
  }
}
</script>
<style lang="scss" scoped>
.px-to-viewport-ignore {
  word-break: break-all;
  padding: 12px;
  font-size: 14px;

  ul {
    list-style-type: disc;
    padding-left: 30px;
  }

  .title {
    margin-bottom: 20px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
  }

  .s {
    font-size: 12px;
  }

  p {
    padding: 0;
    margin: 0;
    margin-bottom: 4px;
  }

  .b {
    font-weight: 600;
  }

  .t1 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  .t2 {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;
  }

  .d {
    margin-bottom: 10px;
  }

  table {
    margin: 20px 0;
    min-height: 25px;
    line-height: 25px;
    text-align: center;
    border-collapse: collapse;
    border: 1px solid #000;
  }

  td {
    border: 1px solid #000;
    padding: 0 10px;
  }
}
</style>
